import { useEffect, lazy, Suspense } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
  Navigate,
} from "react-router-dom";
import Desktop1 from "./components/Desktop";
import DeepLinkHandler from "./components/DeepLinkHandler";
import DeepLinkRedirect from "./components/DeepLinkRedirect";
import './i18n'; // Initialize i18n

const KVKK = lazy(() => import('./components/KVKK'));
const EULA = lazy(() => import('./components/EULA'));

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);



  return (
    <>
      <DeepLinkHandler />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="w-8 h-8 border-4 border-primary-400 border-t-transparent rounded-full animate-spin" /></div>}>
        <Routes>
          <Route path="/" element={<Desktop1 />} />
          <Route path="/kvkk" element={<KVKK />} />
          <Route path="/eula" element={<EULA />} />

          {/* Deep link routes - these will redirect to app */}
          <Route path="/app/*" element={<DeepLinkRedirect />} />
          <Route path="/study/*" element={<DeepLinkRedirect />} />
          <Route path="/subject/*" element={<DeepLinkRedirect />} />
          <Route path="/flashcards/*" element={<DeepLinkRedirect />} />
          <Route path="/folder/*" element={<DeepLinkRedirect />} />
          <Route path="/question/*" element={<DeepLinkRedirect />} />
          <Route path="/session/*" element={<DeepLinkRedirect />} />
          <Route path="/leaderboard/*" element={<DeepLinkRedirect />} />
          <Route path="/league/*" element={<DeepLinkRedirect />} />
          <Route path="/chat/*" element={<DeepLinkRedirect />} />
          <Route path="/premium" element={<DeepLinkRedirect />} />
          <Route path="/settings/*" element={<DeepLinkRedirect />} />
          <Route path="/daily-question" element={<DeepLinkRedirect />} />
          <Route path="/subjects/*" element={<DeepLinkRedirect />} />
          <Route path="/folders" element={<DeepLinkRedirect />} />
          <Route path="/leagues" element={<DeepLinkRedirect />} />
          <Route path="/achievements" element={<DeepLinkRedirect />} />
          <Route path="/activity-points" element={<DeepLinkRedirect />} />
          <Route path="/usage" element={<DeepLinkRedirect />} />
          <Route path="/study-timer" element={<DeepLinkRedirect />} />

          {/* Catch-all route to redirect any undefined route to / */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
